import { PageContentViewModel } from "@/lib/vm/page-content-viewmodel";
import renderReactComponent from "@/react/render-react-component";
import LaunchDarklyBrowser from "@laborchart-modules/launch-darkly-browser";
import type { Root } from "react-dom/client";
import template from "./assignments-list.pug";

export class NewAssignmentsListViewModel extends PageContentViewModel {
   private root: Root | null;
   private reactEnabled: boolean;
   constructor() {
      super(template(), "List");
      this.reactEnabled = LaunchDarklyBrowser.getFlagValue("assignment-list-react-enabled");
      this.root = null;
   }

   addedToParent(): void {
      if (this.reactEnabled) {
         this.root = renderReactComponent(
            "react-assignment-list-mount",
            "AssignmentListContainer",
            { setTitle: (title: string) => this.setTitle(title) },
         );
      }
   }

   removedFromParent(): void {
      if (this.root) {
         this.root.unmount();
      }
   }
}
